module.exports = __webpack_public_path__ + "img/rustore.e797ab8.svg";